module.exports = __webpack_public_path__ + "static/assets/6a7f8d50815b7839c523dbef222fe3fa.gif";